<section
  #section
  class="safehtml-section"
  [ngClass]="{ 'no-margin': removeMargin ? true : false }"
  [class]="parsedClass"
  [innerHTML]="safehtml"></section>
